import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description EmailReadAll icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { EmailReadAll } from '@sravni/design-system-icons'
 *
 * <EmailReadAll />
 * ```
 */
var EmailReadAll = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "EmailReadAll", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.834 10.856V5.032M11.667 14.19H3.334c-.921 0-1.667-.746-1.667-1.667v-7.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.158 3.356H3.343a1.675 1.675 0 0 0-.94 3.063l4.464 3.026a3.36 3.36 0 0 0 3.768 0L15.1 6.42c.459-.312.735-.832.735-1.387v0c0-.927-.75-1.677-1.676-1.677v0ZM17.357 11.833a3.334 3.334 0 1 1-4.714 4.714 3.334 3.334 0 0 1 4.714-4.714Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m16.297 13.541-1.621 1.621-.972-.972", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { EmailReadAll };
//# sourceMappingURL=EmailReadAll.js.map
